export default "__VITE_ASSET__Bt$r3bKv__"